<template>
  <div class="topbar">
    <!-- LOGO -->
    <div class="topbar-left bg-white">
      <a href="javascript:void(0)" class="logo">
        <span class="logo-light">
          <img
            :src="URL_Static_img + companyLogo"
            width="50"
            height="50"
            style="object-fit: cover"
            alt=""
          />
        </span>
        <span class="logo-sm">
          <img
            src="/assets/images/logo-white-2.png"
            width="50"
            height="50"
            alt=""
          />
        </span>
      </a>
    </div>
    <nav class="navbar-custom">
      <ul class="navbar-right list-inline float-right mb-0">
        <!-- notification -->
        <li class="dropdown notification-list list-inline-item">
          <a
            class="nav-link dropdown-toggle arrow-none waves-effect"
            data-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <i class="mdi mdi-bell-outline noti-icon"></i>
            <span class="badge badge-pill badge-danger noti-icon-badge">{{
              totalComunication
            }}</span>
          </a>
          <div
            class="dropdown-menu dropdown-menu-right dropdown-menu-animated dropdown-menu-lg px-1"
          >
            <!-- item-->
            <h6 class="dropdown-item-text">Notifications</h6>
            <div class="slimscroll notification-item-list">
              <!-- item-->

              <!-- item-->
              <a
                href="javascript:void(0);"
                v-for="n in notifications"
                :key="n"
                class="dropdown-item notify-item"
                @click.prevent="notification(n)"
              >
                <div class="notify-icon bg-danger">
                  <i class="mdi mdi-message-text-outline"></i>
                </div>
                <p class="notify-details">
                  <b>Nova Mensagem Recebida</b
                  ><span class="text-muted"
                    >Voce tem uma mensagem nao lida</span
                  >
                </p>
              </a>
            </div>
            <!-- All-->
            <router-link
              to="/notifications"
              href="javascript:void(0);"
              class="dropdown-item text-center notify-all text-primary"
            >
              View all <i class="fi-arrow-right"></i>
            </router-link>
          </div>
        </li>
        <li class="dropdown notification-list list-inline-item">
          <div class="dropdown notification-list nav-pro-img">
            <a
              class="dropdown-toggle nav-link arrow-none nav-user"
              data-toggle="dropdown"
              href="#"
              role="button"
              aria-haspopup="false"
              aria-expanded="false"
            >
              <img
                src=" /assets/images/user-4.jpg"
                alt="user"
                class="rounded-circle"
              />
            </a>
            <div class="dropdown-menu dropdown-menu-right profile-dropdown">
              <!-- item-->
              <router-link
                v-if="user?.data.role[0] === 'Master'"
                class="dropdown-item"
                to="/profile"
                ><i class="mdi mdi-account-circle"></i> Perfil</router-link
              >

              <!-- <a class="dropdown-item d-block" href="#"
                ><span class="badge badge-success float-right">11</span
                ><i class="mdi mdi-settings"></i> Definicoes</a
              > -->

              <div class="dropdown-divider"></div>
              <a
                class="dropdown-item text-danger"
                href="javascript:void(0)"
                @click="logout"
                ><i class="mdi mdi-power text-danger"></i> Sair</a
              >
            </div>
          </div>
        </li>
      </ul>
      <ul class="list-inline menu-left mb-0">
        <li class="float-left">
          <button class="button-menu-mobile open-left waves-effect">
            <i class="mdi mdi-menu"></i>
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { useRouter } from "vue-router";
import CompanyStoreModule from "@/pages/company/CompanyStoreModule";
import { useFinanceStore } from "@/store/useFinanceStore";

export default {
  data() {
    return {
      financeStore: useFinanceStore(),
      user: this.$store.state.auth.user,
      totalComunication: this.$store.state.student.totalComunications,
      notifications: [],
      companyLogo: "",
      URL_Static_img: process.env.VUE_APP_URL_STATIC_RESOURCE_FRONT_SERVER,
    };
  },
  methods: {
    ...mapActions({
      signOut: "auth/logout",
      emptyWeight: "weightSubject/Empty_weight",
    }),
    async getCompanyData() {
      const resp = await CompanyStoreModule.actions.getCompanyLogo();
      this.companyLogo = resp.data.company_logo;
    },

    async logout() {
      this.signOut();
      localStorage.removeItem("user");
      localStorage.removeItem("myProfile");
      // this.$router.push({ name: "login" });
      window.location.href = "/";
      this.financeStore.statistics.inscription_year = 0;
      this.financeStore.statistics.totalExtractNotPayed = 0;
      this.financeStore.statistics.totalExtracto = 0;
      this.financeStore.statistics.totalExtractoPayd = 0;
      this.financeStore.statistics.totalOtherReferencesPayed = 0;
      this.financeStore.statistics.totalReferencesMonthNotPayed = 0;
      this.financeStore.statistics.totalgetReferencePanding = 0;
      this.financeStore.statistics.totalotherReferencesNotPayed = 0;
      this.financeStore.statistics.LoggedYear = new Date().getFullYear();
      this.financeStore.LoggedYear = new Date().getFullYear();
      this.emptyWeight();
    },

    notification(not) {
      localStorage.setItem("open", true);
      localStorage.setItem("notification", JSON.stringify(not));

      window.location.href = "/notifications";
    },
  },

  created() {
    let notifications = localStorage.getItem("myNotifications");
    this.notifications = JSON.parse(notifications);
    this.getCompanyData();

    console.log("====================================");
    console.log(this.user?.data.role[0]);
    console.log("====================================");
  },
};
</script>
